import { Counter, CounterProps } from "./Counter";

export { Counter, CounterProps };
